import { Box } from '@mui/material';
import { useState } from 'react';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Layout from '../../../core/ui/layout/Layout';
import TableContainer from '../../../core/ui/table/TableContainer';
import { TableHeader } from '../../../core/ui/table/tableTypes';
import { Media, Paginated } from '../../../core/utils/types';
import { parseQuery } from '../../../core/utils/utility';
import { Artist } from '../artist';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import ImagePreview from '../../../core/ui/utility/ImagePreview';

const tableHeaders: TableHeader[] = [
  { field: 'fullName', label: 'FullName', align: 'left' },
  { field: 'genre', label: 'Genre', align: 'left' },
  {
    field: 'featuredOnBanner',
    label: 'Featured on banner',
    align: 'left',
    renderItem: (item: number) => (item ? 'Yes' : 'No'),
  },
  {
    field: 'media',
    label: 'Card Image',
    align: 'left',
    renderItem: (item: Media[]) => (
      <ImagePreview media={item.filter((i) => i.collection_name === 'cards')} />
    ),
  },
];
const ArtistList = () => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const { fetchData } = useFetchApiData();
  const { callApi } = useSendApiData();

  const handleFetchData = async (query: any, cb: (c: number) => void) => {
    await fetchData(`artists${parseQuery(query)}`, {
      onSuccess: ({ total, data: apiData }: Paginated<Artist>) => {
        setData(apiData);
        cb(total);
      },
    });
  };

  const handleDelete = async (id: number | string, showMessage = true) => {
    let success = false;

    await callApi({
      endpoint: `auth-bana29/artists/${id}`,
      data: {},
      method: 'delete',
      onSuccess: async () => {
        if (showMessage) toastMessage('Item Removed');
        success = true;
      },
      onError: () => {
        if (showMessage)
          toastError('Something went wrong while deleting. Try again');
      },
    });

    return success;
  };

  return (
    <>
      <Layout>
        <Box sx={{ p: 2, maxWidth: 1200 }}>
          <TableContainer
            modelToken="artists"
            tableHeaders={tableHeaders}
            data={data}
            modelLabel="Artists"
            actions={{
              onFetchData: handleFetchData,
              onDelete: handleDelete,
            }}
            routes={{
              edit: '/artists/edit',
              create: '/artists/create',
              delete: '/artists',
              view: '/artists',
            }}
            settings={{
              canCreate: true,
              canEdit: true,
              canDelete: true,
              canViewItem: false,
            }}
          />
        </Box>
      </Layout>
    </>
  );
};

export default ArtistList;
